import { render, staticRenderFns } from "./lianTuoCompany.vue?vue&type=template&id=894fc9b6&"
import script from "./lianTuoCompany.js?vue&type=script&lang=js&"
export * from "./lianTuoCompany.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports